import { ENDPOINT } from '@old/data/core/endpoints';
import { BACKEND } from '@old/services/core/fetch-backend';

import { AvailableDeviceData } from './available-device-list.types';

// deprecated service ref.: getAvailableDevicesService_DEPRECATED

// implementado ✅
export async function listAvailableDeviceService() {
  const { response, data } = await BACKEND.get<AvailableDeviceData>(ENDPOINT.FREE_DEVICES);

  return {
    response,
    summary: data,
  };
}
